import * as yup from 'yup';

import { ContentTypeEnum } from 'constants-content';
import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { PropertiesInterface } from '../../types/properties/Property';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_LANE } from '../constants';
import createShapeFromProperties from '../createShapeFromProperties';

const properties: PropertiesInterface = {
  _id: {
    type: 'UUID',
    validators: [
      {
        name: 'Required',
        value: true,
      },
    ],
  },
  type: {
    type: 'String',
    validators: [
      {
        name: 'In',
        value: [
          ContentTypeEnum.Content,
          ContentTypeEnum.Notice,
          ContentTypeEnum.ScheduledContent,
          ContentTypeEnum.ScheduledNotice,
          ContentTypeEnum.Promotion,
          ContentTypeEnum.Static,
          ContentTypeEnum.Perk,
        ],
      },
    ],
  },
};

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use ContentType from application-types instead.
 */
export class ContentType extends ObjectTypeBase {
  group = TYPE_GROUP_LANE;

  name = 'Content';

  friendlyName = 'Content';

  contexts = [TypeContextEnum.Block, TypeContextEnum.Content];

  superUserOnly = false;

  get example() {
    return {
      _id: '000000Be3RPQB9nF9WZlwQ',
      type: ContentTypeEnum.Content,
    };
  }

  get default(): any {
    return {
      _id: null,
    };
  }

  buildSchema() {
    return yup
      .object()
      .nullable()
      .default(null)
      .shape(createShapeFromProperties(properties));
  }

  properties = properties;
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use Content from application-types instead.
 */
const definition = new ContentType();

Types.addBaseType(definition);
export default definition;
